export var toolbarPosition;
(function (toolbarPosition) {
    toolbarPosition["TOP"] = "top";
    toolbarPosition["BOTTOM"] = "bottom";
    toolbarPosition["LEFT"] = "left";
    toolbarPosition["RIGHT"] = "right";
    toolbarPosition["NONE"] = "none";
})(toolbarPosition || (toolbarPosition = {}));
//# sourceMappingURL=Enums.js.map